import React, {useRef, useState} from 'react';
import styled, {css, keyframes} from 'styled-components';
import { HoverElement, HoverElementText, HoverElementTitle } from '../HoverElement/HoverElement';

const StyledSingleBar = styled.div`
    flex: 1;
    position: relative;
    min-width: 0;
    z-index: ${({$isHovered}) => ($isHovered ? 1 : 'auto')}; // Lift the column on hover so the HoverElement stacks above other bars
`;

const Track = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`;

const slideScaleIn = keyframes`
    from {
        transform: scaleY(0);
    }
    to {
        transform: scaleY(1);
    }
`;

const Fill = styled.div`
    width: 100%;
    height: ${({$height}) => $height}%;
    background: ${({$color}) => `${$color}66`}; // 66 = 40% opacity
    min-height: 2px;
    position: relative;
    cursor: pointer;
    transform-origin: bottom center;
    
    ${({$pdfExport}) => !$pdfExport && css`
        animation: ${slideScaleIn} 0.35s ease ${({$delay}) => $delay}ms both;
    `};

    &:hover {
        background: ${({$color}) => `${$color}B3`}; // B3 = 70% opacity
    }
`;

export const SingleBar = ({item, yMax, barIndex = 0, pdfExport = false}) => {
    const [isHovered, setIsHovered] = useState(false);
    const [hoverY, setHoverY] = useState(0);
    const fillRef = useRef(null);

    const handleMouseMove = (e) => {
        const rect = fillRef.current.getBoundingClientRect();
        window.requestAnimationFrame(() => {
            setHoverY(e.clientY - rect.top);
        });
    };

    return (
        <StyledSingleBar $isHovered={isHovered}>
            <Track>
                <Fill
                    ref={fillRef}
                    onMouseMove={handleMouseMove}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    $color={item.color}
                    $height={(item.totalScore / yMax) * 100}
                    $delay={barIndex * 20}
                    $pdfExport={pdfExport}
                >
                    <HoverElement 
                        $visible={isHovered} 
                        $placement="top-center"
                        $noWrap={true}
                        style={{top: hoverY + 'px'}}
                    >
                        <HoverElementTitle $small={true}>{item.title}</HoverElementTitle>
                        <HoverElementText $small={true}>Score: {item.totalScore}</HoverElementText>
                    </HoverElement>
                </Fill>
            </Track>
        </StyledSingleBar>
    );
};